import React from 'react';

import { Table } from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';
import {
  useSkeletonLoadingRows,
  TableSkeletonLoadingRow,
} from '@adsk/alloy-react-table';

export type LoadingStateProps = {
  table: Table<EntitlementsProject>;
  numberOfRows?: number;
};

export const LoadingState = ({
  table,
  numberOfRows = 25,
}: LoadingStateProps) => {
  const { getSkeletonLoadingRows, getSkeletonLoadingRowProps } =
    useSkeletonLoadingRows({
      table,
      numberOfRows,
    });

  return (
    <>
      {getSkeletonLoadingRows().map((skeletonRow) => (
        <TableSkeletonLoadingRow
          key={skeletonRow.id}
          data-testid="row-loading"
          {...getSkeletonLoadingRowProps(skeletonRow)}
        />
      ))}
    </>
  );
};
